const businessDrawerItems = [
  {
    text: "dashboard",
    value: "dashboard",
    url: "/dashboard",
    eventName: "dashboard_view",
    iconSrc: "icons/dashboard-icon.svg",
  },
  {
    text: "members",
    value: "members",
    url: "/members",
    eventName: "members_view",
    iconSrc: "icons/people-icon.svg",
  },
  {
    text: "partners",
    value: "partners",
    url: "/partners",
    eventName: "partners_view",
    iconSrc: "icons/business-icon.svg",
  },
  // {
  //   text: "genealogy",
  //   value: "genealogy",
  //   url: "/genealogy",
  //   eventName: "genealogy_view",
  //   iconSrc: "icons/genealogy-icon.svg"
  // },
  {
    text: "action_hub",
    value: "actionhub",
    url: "/actionhub",
    eventName: "action_hub_view",
    iconSrc: "icons/actionhub-icon.svg",
  },
  {
    text: "centurion",
    value: "centurion",
    url: "/centurion",
    eventName: "centurion_view",
    iconSrc: "icons/centurion-icon.svg",
  },
  {
    text: "referral_links",
    value: "referrals",
    url: "/referrals",
    eventName: "referral_links_view",
    iconSrc: "icons/link-icon.svg",
  },
  {
    text: "earnings",
    value: "earnings",
    url: "/earnings",
    eventName: "earnings_view",
    iconSrc: "icons/earnings-icon.svg",
  },
  {
    text: "order_history",
    value: "orders",
    url: "/orders",
    eventName: "order_history_view",
    iconSrc: "icons/order-history-icon.svg",
  },
  {
    text: "settings",
    value: "settings",
    url: "/settings/my-profile",
    eventName: "settings_view",
    iconSrc: "icons/settings-icon.svg",
  },
];

const resourceDrawerItems = [
  {
    text: "library",
    value: "library",
    url: "/library",
    eventName: "library_view",
    iconSrc: "icons/library-icon.svg",
    tags: [],
  },
  {
    text: "help_center",
    value: "external-help",
    url: "",
    eventName: "help_center_view",
    tags: [],
  },
  {
    text: "shop_feel_great",
    value: "shop-feel-great",
    url: "",
    externalUrl: process.env.REACT_APP_FEEL_GREAT_URL,
    eventName: "shop_feel_great_view",
    tags: [],
  },
  {
    text: "shop_unicity",
    value: "shop-unicity",
    url: "",
    eventName: "shop_unicity_view",
    tags: [],
  },
];

const AFFILIATE_HIDDEN_BUSINESS = ["partners", "actionhub", "centurion"];
const AFFILIATE_HIDDEN_RESOURCES = ["external-help", "shop-feel-great"];

const getBusinessDrawerItems = (isAffiliate) => {
  if (!isAffiliate) return businessDrawerItems;
  return businessDrawerItems
    .filter((item) => !AFFILIATE_HIDDEN_BUSINESS.includes(item.value))
    .map((item) =>
      item.value === "members" ? { ...item, text: "customers" } : item
    );
};

const getResourceDrawerItems = (isAffiliate) => {
  if (!isAffiliate) return resourceDrawerItems;
  return resourceDrawerItems.filter(
    (item) => !AFFILIATE_HIDDEN_RESOURCES.includes(item.value)
  );
};

export {
  businessDrawerItems,
  resourceDrawerItems,
  getBusinessDrawerItems,
  getResourceDrawerItems,
};
